export const user = state => state.user.info;
export const userList = state => state.user.list;
export const userVenuesList = state => state.user.venues.list;
export const userVenuesListShow = state => state.user.venues.list.filter(v => v.isShow);
export const userVenuesInfo = state => ({
  isFetching: state.user.venues.isFetching,
  page: state.user.venues.page,
  lastPage: state.user.venues.lastPage,
});
